import React, { useState } from 'react';

import { number } from '~/helpers';

import Filters from './components/Filters/index';
import Graphic from './components/Graphic';
import * as S from './styles';

const delayRefresh = 2;

const graph = [
  {
    id: 1,
    title: 'Leitura DVEC Posto/Comboio',
    url: 'posto',
  },
  {
    id: 2,
    title: 'Leitura DVEC Veículo ',
    url: 'veiculo',
  },
  {
    id: 3,
    title: 'Leitura DVEC Dia',
    url: 'dia',
  },
];

export default function DashboardContingencia() {
  const [params, setParams] = useState({
    iddia: 7,
    idfilter: '0',
    idposto: [],
  });

  return (
    <S.Wrapper>
      <S.HeaderWrapper>
        <Filters params={params} setParams={setParams} />
      </S.HeaderWrapper>

      <S.GraphContainer>
        {graph.map((mapobj) => (
          <Graphic
            url={mapobj.url}
            key={mapobj.id}
            title={mapobj.title}
            params={params}
          />
        ))}
      </S.GraphContainer>
    </S.Wrapper>
  );
}
